import { render, staticRenderFns } from "./btn-quarternary.vue?vue&type=template&id=99f27860&scoped=true&"
import script from "./btn-quarternary.vue?vue&type=script&lang=js&"
export * from "./btn-quarternary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f27860",
  null
  
)

export default component.exports